module.exports = ".text-secondary,.text-secondary-body {\n    word-wrap: break-word;\n    -webkit-hyphens: auto;\n        -ms-hyphens: auto;\n            hyphens: auto;\n}\n.text-secondary {\n    max-width: 80%;\n}\n.text-secondary-body {\n    width: 400px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/notice-board/notice-board.component.css
// module id = ./src/app/notice-board/notice-board.component.css
// module chunks = main